import { render, staticRenderFns } from "./CompilationSection.vue?vue&type=template&id=38b46a38&scoped=true&"
import script from "./CompilationSection.vue?vue&type=script&lang=js&"
export * from "./CompilationSection.vue?vue&type=script&lang=js&"
import style0 from "./CompilationSection.vue?vue&type=style&index=0&id=38b46a38&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b46a38",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CompilationSliderForMobile: require('/home/bitrix/frontend/components/compilations/CompilationSliderForMobile.vue').default,CompilationsList: require('/home/bitrix/frontend/components/compilations/CompilationsList.vue').default,Loader: require('/home/bitrix/frontend/components/other/Loader.vue').default,Button: require('/home/bitrix/frontend/components/other/Button.vue').default})
